import { render } from "./UserFlows.vue?vue&type=template&id=3183edfe&scoped=true"
import script from "./UserFlows.vue?vue&type=script&lang=js"
export * from "./UserFlows.vue?vue&type=script&lang=js"

import "./UserFlows.vue?vue&type=style&index=0&id=3183edfe&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3183edfe"]])

export default __exports__